<script lang="ts">
  import PayrollTransactionHistory from '../../components/admin/payroll/PayrollTransactionHistory.svelte';
</script>

<div class="payroll-transaction-history-page-wrapper">
  <PayrollTransactionHistory />
</div>

<style>
  .payroll-transaction-history-page-wrapper {
    min-height: 100vh;
    background-color: #f9fafb;
  }
</style> 